import type {TestDriveResponseBody} from '@dms/api/sales';

import {EMPTY_PLACEHOLDER} from 'shared/web';

/**
 * A business customer has only a trade name and a natural person only a founding person, so
 * interpolating the person fields on their own renders "null null" for every company.
 */
export const getTestDriveCustomerName = (testDrive: TestDriveResponseBody) =>
  testDrive.customerTradeName ||
  `${testDrive.customerFoundingPersonFirstName ?? ''} ${testDrive.customerFoundingPersonLastName ?? ''}`.trim() ||
  EMPTY_PLACEHOLDER;
